import 'bootstrap/dist/css/bootstrap.min.css'
import {Reset} from "styled-reset";
import {
    BrowserRouter,
    HashRouter,
    Route,
    Routes
} from "react-router-dom";
import './css/Styles.css'
import './App.css';
import { createTheme, ThemeProvider } from '@mui/material';
import CssBaseline from '@mui/material/CssBaseline';
import AdvertisingManagement from "./component/advertisement/AdvertisingManagement";
import AdvertisingView from "./component/advertisement/AdvertisingView";
import AdvertisingAdd from "./component/advertisement/AdvertisingAdd";
import AdvertisingModify from "./component/advertisement/AdvertisingModify";
import {Provider} from "react-redux";
import store from "./redux/store"
import {PersistGate} from "redux-persist/integration/react";
import {persistStore} from "redux-persist";
import Login from "./component/utill/Login";
import UserManagement from './component/UserManagement'
import DeletedUserManagement from "./component/DeletedUserManagement";
import DeviceManagement from "./component/device/DeviceManagement";
import OrderingSerialNumber from "./component/device/OrderingSerialNumber";
import AppVersionManagement from "./component/AppVersionManagement";
import PopupManagement from "./component/popup/PopupManagement";
import PopupAdd from "./component/popup/PopupAdd";
import PopupModify from "./component/popup/PopupModify";
import ActiveUserChart from "./component/chart/ActiveUserChart";
import APIUsageChart from "./component/chart/APIUsageChart";
import RPUserChart from "./component/chart/RPUserChart";
import RubieHudAdChart from "./component/chart/RubieHudAdChart";
import RpCallHistory from "./component/history/RpCallHistory";
import KakaoApiCallHistory from "./component/history/KakaoApiCallHistory";
import HistoryPageCallLog from './component/history/HistoryPageCallLog';
import AuthorityManagement from "./component/authority/AuthorityManagement"
import AuthorityAdd from "./component/authority/AuthorityAdd";
import AuthorityModify from "./component/authority/AuthorityModify";
import ClientManagement from "./component/client/ClientManagement";
import ClientAdd from "./component/client/ClientAdd";
import ClientModify from "./component/client/ClientModify";
import WebUserManagement from "./component/webuser/WebUserManagement";
import WebUserAdd from "./component/webuser/WebUserAdd";
import WebUserModify from "./component/webuser/WebUserModify";
import PasswordChange from "./component/utill/PasswordChange";
import NotFound from "./component/utill/NotFound";


const theme = createTheme({
    typography: {
        fontFamily: 'NotoSansKR, Malgun Gothic, 맑은 고딕, Dotum, 돋움, Helvetica Neue, Helvetica, Apple SD Gothic Neo, sans-serif',
    },
    components: {
        MuiCssBaseline: {
            styleOverrides: {
                '@global': {
                    '@font-face': {
                        fontFamily: 'NotoSansKR',
                        src: `local('NotoSansKR'),
            url('./assets/fonts/NotoSansKR-Regular.otf') format('opentype')`,
                    },
                    body: {
                        fontFamily: 'NotoSansKR, Malgun Gothic, 맑은 고딕, Dotum, 돋움, Helvetica Neue, Helvetica, Apple SD Gothic Neo, sans-serif !important',
                    },
                },
            },
        },
    },
});

const persistor = persistStore(store);

function App() {
    return (
        <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
                <Reset/>
                <ThemeProvider theme={theme}>
                <CssBaseline/>
                <BrowserRouter basename={`${process.env.REACT_APP_SERVER}`}>
                    <Routes>
                        <Route path="/" element={<Login/>}></Route>
                        <Route path="/login" element={<Login/>}></Route>
                        <Route path="/UserManagement" element={<UserManagement/>}></Route>
                        <Route path="/DeletedUserManagement" element={<DeletedUserManagement/>}></Route>
                        <Route path="/DeviceManagement" element={<DeviceManagement/>}></Route>
                        <Route path="/OrderingSerialNumber" element={<OrderingSerialNumber/>}></Route>
                        <Route path="/AppVersionManagement" element={<AppVersionManagement/>}></Route>
                        <Route path="/AdvertisingManagement" element={<AdvertisingManagement/>}></Route>
                        <Route path="/AdvertisingView" element={<AdvertisingView/>}></Route>
                        <Route path="/AdvertisingAdd" element={<AdvertisingAdd/>}></Route>
                        <Route path="/AdvertisingModify" element={<AdvertisingModify/>}></Route>
                        <Route path="/PopupManagement" element={<PopupManagement/>}></Route>
                        <Route path="/PopupAdd" element={<PopupAdd/>}></Route>
                        <Route path="/PopupModify" element={<PopupModify/>}></Route>
                        <Route path="/ActiveUserChart" element={<ActiveUserChart/>}></Route>
                        <Route path="/APIUsageChart" element={<APIUsageChart/>}></Route>
                        <Route path="/RPUserChart" element={<RPUserChart/>}></Route>
                        <Route path="/RubieHudAdChart" element={<RubieHudAdChart/>}></Route>
                        <Route path="/RPCallHistory" element={<RpCallHistory/>}></Route>
                        <Route path="/KakaoApiCallHistory" element={<KakaoApiCallHistory/>}></Route>
                        <Route path="/HistoryPageCallLog" element={<HistoryPageCallLog/>}></Route>
                        <Route path="/AuthorityManagement" element={<AuthorityManagement/>}></Route>
                        <Route path="/AuthorityAdd" element={<AuthorityAdd/>}></Route>
                        <Route path="/AuthorityModify" element={<AuthorityModify/>}></Route>
                        <Route path="/ClientManagement" element={<ClientManagement/>}></Route>
                        <Route path="/ClientAdd" element={<ClientAdd/>}></Route>
                        <Route path="/ClientModify" element={<ClientModify/>}></Route>
                        <Route path="/WebUserManagement" element={<WebUserManagement/>}></Route>
                        <Route path="/WebUserAdd" element={<WebUserAdd/>}></Route>
                        <Route path="/WebUserModify" element={<WebUserModify/>}></Route>
                        <Route path="/PasswordChange" element={<PasswordChange/>}></Route>
                        <Route path="/*" element={<NotFound/>}></Route>
                    </Routes>
                </BrowserRouter>
                </ThemeProvider>
            </PersistGate>
        </Provider>
    )
}

export default App;
